import RedirectsWidget from './RedirectsWidget';


export default RedirectsWidget;
